import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BuscarSomenteObrasService } from 'src/app/filtro-lateral/service/buscar-somente-obras/buscar-somente-obras.service';
import { DropdownToggleDirective } from 'src/app/shared/directives/dropdown-toggle.directive';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-filtro-busca-somente',
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownToggleDirective],
  templateUrl: './filtro-busca-somente.component.html',
  styleUrls: ['./filtro-busca-somente.component.scss'],
})
export class FiltroBuscaSomenteComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  buscarSomenteObras: any[] = [];
  temAcessoModulo = true;

  private _checkedOptionsIds: number[] = [];
  @Input() set checkedOptionsIds(value: number[] | undefined) {
    this._checkedOptionsIds = value ?? [];
  }
  get checkedOptionsIds(): number[] {
    return this._checkedOptionsIds;
  }
  @Output() buscarSomenteChange = new EventEmitter<any[]>();
  @Input() disabled: boolean = false;

  private isInitializing = true;

  constructor(
    private readonly _buscarSomenteService: BuscarSomenteObrasService,
  ) {}

  ngOnInit(): void {
    this._buscarSomenteService.buscarSomente().subscribe((dados) => {
      this.buscarSomenteObras = (dados || []).map((item: any) => ({
        ...item,
        checked:
          this.checkedOptionsIds.length === 0 &&
          (item.id === 1 || item.id === 2)
            ? true
            : this.checkedOptionsIds.includes(item.id),
      }));
      this.isInitializing = false;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['checkedOptionsIds'] && !this.isInitializing) {
      this.buscarSomenteObras.forEach((item) => {
        item.checked = this.checkedOptionsIds.includes(item.id);
      });
    }
  }

  onCheckboxChange(event: Event, option: any) {
    option.checked = (event.target as HTMLInputElement).checked;
    this.emitirSelecionados();
  }

  emitirSelecionados() {
    if (!this.isInitializing) {
      const selecionados = this.buscarSomenteObras.filter((o) => o.checked);
      this.buscarSomenteChange.emit(selecionados);
    }
  }

  trackById(index: number, item: any) {
    return item.id;
  }
}
